class BusinessSignUp {
  constructor() {
    if(navigator.cookieEnabled){
      this.dataEvents(this);
   }else{
      alert("Cookies are currently disabled in your browser. Please enable cookies to continue.");
   }
  }
  dataEvents(that){
    document.addEventListener("click", function (e) {
      if (e.target.closest(".business-signup-step-btn")) {
        e.preventDefault();
        let data_par = e.target.closest(".business-signup-step");
        let data_step = parseInt(data_par.getAttribute("data-step"));
        let main_par = e.target.closest(".business-signup");
        let is_prev = e.target.classList.contains("prev-step");
        let data_next = data_step + 1;
        let is_valid = true;
        if(!is_prev){
          for(let i=0;i< data_par.querySelectorAll(".business-form-field").length;i++){
            let curr_input = data_par.querySelectorAll(".business-form-field")[i];
            let input_name = curr_input["name"];
            if(!curr_input.checkValidity()){
              curr_input.reportValidity();
              return false;
            }
            else if(input_name == "billing_emails"){
              let email_regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,8})+$/;
              let email_inputs = curr_input.value.split(",");
              for (let j=0;j < email_inputs.length ; j++){
                let curr_email = email_inputs[j].trim();
                let is_valid = email_regex.test(curr_email);
                if(!is_valid){
                  let err_span = curr_input.parentElement.querySelector(".form-label-err");
                  err_span.textContent = "Enter a correct email format.";
                  curr_input.focus();
                  setTimeout(function(){
                    err_span.textContent = "";
                  },4000);
                  is_valid = false;
                  return false;
                }
              }
            }else if(input_name == "billing_phone" || input_name == "buyer_contact_phone"){
              let phone_val = curr_input.value;
              phone_val = phone_val.replaceAll("-","");
              if(phone_val.length != 10){
                let err_span = curr_input.parentElement.querySelector(".form-label-err");
                err_span.textContent = "Enter correct phone number";
                curr_input.focus();
                setTimeout(function(){
                  err_span.textContent = "";
                },4000);
                return false;
              }
            }
            if(!is_valid){
              return false;
            }
          }
        }else{
          data_next = data_step - 1;
        }
        if (!is_prev) {
          main_par.querySelector(`.business-bread-item[data-step="${data_next}"]`).parentElement.
          classList.add("font-bold");
          const bread_next = main_par.querySelector(`.business-bread-item[data-step="${data_step}"]`);
          bread_next.classList.add("before-animate-fillin");
          setTimeout(function(){bread_next.classList.remove("before-animate-fillin");},1000);
          bread_next.classList.add("before-width-full");
          bread_next.classList.remove("before-width-null")
        } else {
          main_par.querySelector(`.business-bread-item[data-step="${data_step}"]`).parentElement.
          classList.remove("font-bold");
          const bread_next = main_par.querySelector(`.business-bread-item[data-step="${data_next}"]`);
          bread_next.classList.add("before-animate-fillout");
          setTimeout(function(){bread_next.classList.remove("before-animate-fillout");},1000);
          bread_next.classList.remove("before-width-full");
          bread_next.classList.add("before-width-null");
        }
        data_par.style.display = "none";
        main_par.querySelector(`.business-signup-step[data-step="${data_next}"]`).style.display = "block";
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      if (e.target.closest(".busin-signup-submit")) {
        e.preventDefault();
        const btn = e.target.closest(".busin-signup-submit");
        const form = btn.closest("#business-signup-form");
        const page = form.closest(".business-signup");
        const emails = page.querySelectorAll("[name='buyer_contact_email']");
        const password = page.querySelector("[name='password']");
        if (emails[0].value !== emails[1].value) {
          const err = emails[1].parentElement.querySelector(".form-label-err");
          err.textContent = emails[1].value ? "Email is not matching with buyer email" : "Enter your email address";
          emails[1].focus();
          setTimeout(() => (err.textContent = ""), 4000);
          return;
        }
        if (!password.checkValidity()) {
          password.reportValidity();
          return;
        }
        btn.setAttribute('disabled',true);
        btn.setAttribute('loading',true);
        const formData = new URLSearchParams(new FormData(form)).toString();
        fetch(tayst.interfaceBusinessSignup, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            shopid: tayst.shopid,
            data: formData,
            action: tayst.action.business_signup_submit,
            shopify_customer_id: tayst.shopifycustomerid,
          }),
        })
        .then((r) => r.json())
        .then((ret) => {
          const themeModal = document.querySelector('theme-modal');
          const tpl = themeModal.querySelector('template[data-theme-modal-content]');
          const fragment = tpl.content; // DocumentFragment
          const popup = fragment.querySelector('.signup-success-wrapper');
          if(ret.status == 0){
            popup.querySelector(".business-signup-error-msg").style.display = "none";
            popup.querySelector(".business-signup-success-msg").style.display = "block";
            document.querySelector(".signup-success-trigger").click();
          }else{
            popup.querySelector(".business-signup-error-msg").innerHTML = ret.msg;
            popup.querySelector(".business-signup-error-msg").style.display = "block";
            popup.querySelector(".business-signup-success-msg").style.display = "none";
            document.querySelector(".signup-success-trigger").click();
          }
          form.reset();
          btn.setAttribute('disabled',false);
          btn.setAttribute('loading',false);
          page.querySelectorAll(".business-signup-step").forEach((s) => (s.style.display = "none"));
          page.querySelector(".business-signup-step[data-step='1']").style.display = "block";
          page.querySelectorAll(".business-bread-item").forEach((b) => {
            b.classList.remove("before-width-full", "font-bold");
            b.parentElement.classList.remove("font-bold");
          });
        });
      }
    });
    document.addEventListener("change", function (e) {
      if (e.target.closest(".business-signup-select")) {
        const select = e.target.closest(".business-signup-select");
        if (!select) return;
        const val = select.value.toLowerCase();
        const targetId = select.dataset.id;
        const block = document.querySelector(`.select-target-block[data-id="${targetId}"]`);
        const input = block.querySelector("input");
        if (val === "other") {
          block.style.display = "block";
          select.name = "";
          input.name = targetId;
          input.required = true;
        } else {
          block.style.display = "none";
          select.name = targetId;
          input.name = "";
          input.required = false;
        }
      }
    });
    document.addEventListener("input", function (e) {
      if (e.target.matches("#buyer_contact_phone, #billing_phone")) {
        let val = e.target.value.replace(/[^0-9]/g, "");
        if (val.length > 10) val = val.slice(0, 10);
        if (val.length > 6)
          val = `${val.slice(0, 3)}-${val.slice(3, 6)}-${val.slice(6)}`;
        else if (val.length > 3)
          val = `${val.slice(0, 3)}-${val.slice(3)}`;
        e.target.value = val;
      }
    });
  }
}
new BusinessSignUp();